<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="6">
      <v-card>
        <v-toolbar color="primary" dark flat dense>
          <v-toolbar-title>{{ $t("communications") }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-6">
          <v-alert type="info" text>
            {{ $t("ssoRequired") }}
          </v-alert>
          <p class="mb-0">{{ $t("ssoInstructions") }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="$router.go(-1)">
            {{ $t("goBack") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "LoginWithSSO",
};
</script>

<i18n>
{
  "en": {
    "communications": "Communications",
    "ssoRequired": "This service requires an SSO login.",
    "ssoInstructions": "Please log out and select Login with SSO to access Communications.",
    "goBack": "Go back"
  },
  "de": {
    "communications": "Kommunikation",
    "ssoRequired": "Dieser Dienst benötigt eine SSO-Anmeldung.",
    "ssoInstructions": "Bitte melden Sie sich ab und wählen Sie auf der Login-Seite Mit SSO anmelden, um auf Kommunikation zuzugreifen.",
    "goBack": "Zurück"
  }
}
</i18n>
